webpackJsonp([260825524212085],{

/***/ 337:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Banner = __webpack_require__(18);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	__webpack_require__(337);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContentPageTemplate = function (_React$Component) {
	  _inherits(ContentPageTemplate, _React$Component);
	
	  function ContentPageTemplate() {
	    _classCallCheck(this, ContentPageTemplate);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ContentPageTemplate.prototype.componentDidMount = function componentDidMount() {
	    var isBrowser = typeof window !== 'undefined';
	    var AOS = isBrowser ? __webpack_require__(3) : undefined;
	    this.aos = AOS;
	    this.aos.init();
	  };
	
	  ContentPageTemplate.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.aos.refresh();
	  };
	
	  ContentPageTemplate.prototype.render = function render() {
	    var post = this.props.data.markdownRemark;
	    return _react2.default.createElement(
	      'main',
	      null,
	      _react2.default.createElement(_Banner2.default, {
	        title: post.frontmatter.title,
	        tagline: post.frontmatter.tagline
	      }),
	      _react2.default.createElement('div', { className: 'container',
	        dangerouslySetInnerHTML: { __html: post.html }
	      })
	    );
	  };
	
	  return ContentPageTemplate;
	}(_react2.default.Component);
	
	exports.default = ContentPageTemplate;
	
	
	{} /* <div class="container">
	   <Helmet title={`Your Blog Name - ${post.frontmatter.title}`} />
	   <div class="blog-post">
	    <h1>
	      {post.frontmatter.title}
	    </h1>
	    <div class="blog-post-content"
	      dangerouslySetInnerHTML={{ __html: post.html }}
	    />
	   </div>
	   </div> */
	
	// export default function Template({
	//   data // this prop will be injected by the GraphQL query we'll write in a bit
	// }) {
	//   const { markdownRemark: post } = data; // data.markdownRemark holds our post data
	//   return (
	//     <main>
	//       <Banner />
	//       <div class="blog-post-container">
	//         <Helmet title={`Your Blog Name - ${post.frontmatter.title}`} />
	//         <div class="blog-post">
	//           <h1>
	//             {post.frontmatter.title}
	//           </h1>
	//           <div
	//             class="blog-post-content"
	//             dangerouslySetInnerHTML={{ __html: post.html }}
	//           />
	//         </div>
	//       </div>
	//     </main>
	//   );
	// }
	
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-content-page-index-js-32f68db9437407e960f7.js